import React from 'react'
import PropTypes from 'prop-types'

const renderCheckbox = ({ input, label, meta: { touched, error } }) => {
  const { value: checked } = input


  return (
    <div className="form-group">
      <label style={{ fontSize: 12, textTransform: 'none' }}>
        <input className="mr-2" {...input} checked={checked} type="checkbox" /> {label}
      </label>
      {touched &&
        error && (
          <h6
            className="text-danger small text-justify"
            style={{ marginTop: '5px' }}
          >
            {error}
          </h6>
        )}
    </div>
  )
}


renderCheckbox.defaultProps = {
  label: '',
}

renderCheckbox.propTypes = {
  className: PropTypes.string,
  input: PropTypes.any.isRequired,
  label: PropTypes.any,
  meta: PropTypes.any,
}

export default renderCheckbox



// WEBPACK FOOTER //
// ./src/components/ui/forms/renderCheckbox.js